import api from "./apiService";

export function getDashboard() {
  return api
    .get(`admin/dashboard`)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}
export function getAdminMembers() {
  return api
    .get(`auth/admin/users`)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}
export function getAdminRoles() {
  return api
    .get(`auth/admin/roles`)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}
export function updateAdminRole(data) {
  return api
    .patch(`auth/admin/add-role`, data)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}
export function removeAdminRole(data) {
  return api
    .delete(`auth/admin/user-roles/${data}`)
    .then(data => {
      return data.data;
    })
    .catch(err => {
      return err.response;
    });
}
export function deleteAdminUser(userId) {
  return api
    .delete(`auth/admin/delete/${userId}`)
    .then(data => {
      return data.data;
    })
    .catch(err => {
      return err.response;
    });
}

export function createNewAdminUser(data) {
  return api
    .post(`auth/admin/users`, data)
    .then(data => {
      return data;
    })
    .catch(err => {
      return err.response;
    });
}

export function addAdminPermission(data) {
  return api
    .post(`auth/admin/users/permissions`, data)
    .then(data => {
      return data;
    })
    .catch(err => {
      return err.response;
    });
}

export function removeAdminPermission(permissionId) {
  return api
    .delete(`auth/admin/users/permissions/${permissionId}`)
    .then(data => {
      return data.data;
    })
    .catch(err => {
      return err.response;
    });
}



export function setAdminPassword({ password, token }) {
  api.interceptors.request.use(config => {
    config.headers["Authorization"] = `Bearer ${token}`;
    return config;
  });

  return api
    .patch(`auth/admin/set-password`, { password })
    .then(data => data.data)
    .catch(err => err.response);
}

export function forgotPassword(body) {
  return api
    .post(`auth/admin/password-reset`, body)
    .then(data => data.data)
    .catch(err => err.response);
}



//////////////////
// WEBPACK FOOTER
// ./services/dashboard.js
// module id = null
// module chunks = 